// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__32tmf","notes":"Notes_notes__F7nnv"};